import React, { Component } from 'react';
import { Fstyr } from './Fstyr.js';

type Props = {
    show: boolean
    onAccept: (value: string) => void;
    onDecline: () => void;
    label: string;
    value: string;
};

type State = {
    showSpinner: boolean
    value: string
};

export class FstyrNoteModal extends Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            showSpinner: false,
            value: this.props.value
        };
    }

    componentDidUpdate(prevProps: Props) {
        if (prevProps.show && !this.props.show) this.setState({ showSpinner: false })
        if (prevProps.value !== this.props.value) this.setState({ value: this.props.value })
    }

    render() {
        return (
            this.props.show &&
            <div className="fstyr-modal-background">
                <div className="fstyr-modal-container">
                    <Fstyr.Segment
                        title={this.props.label}
                        isPageTitle={true}
                    />
                    <Fstyr.Segment
                        title={this.props.label}
                        isPageTitle={true}
                    >
                        <textarea
                            className="form-input modal-textarea"
                            onChange={(e) => this.setState({ value: e.target.value })}
                            value={this.state.value}
                        />
                    </Fstyr.Segment>

                    <Fstyr.Segment
                        isPageTitle={true}
                    >
                        <div className="fstyr-left-button-group">
                            <Fstyr.Button
                                label={"Gem"}
                                type={"primary"}
                                onClick={() => {
                                    this.setState({ showSpinner: true })
                                    this.props.onAccept(this.state.value)
                                }}
                                disabled={this.state.showSpinner}
                            />
                            <Fstyr.Button
                                label={"Annullér"}
                                type={"secondary"}
                                onClick={() => { this.props.onDecline() }}
                            />
                            <Fstyr.Spinner
                                show={this.state.showSpinner}
                            />
                        </div>
                    </Fstyr.Segment>
                </div>
            </div>
        );
    }

}
